// src/features/system/edge-tasks/hooks/useEdgeMetrics.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchEdgeMetrics,
  requestSystemMetrics,
  type EdgeMetricsResponse,
  type EdgeMetricsQuery,
} from '../api/edgeMetricsApi';

const QUERY_KEY = ['system', 'edge-metrics'];

export function useEdgeMetrics(query: EdgeMetricsQuery = {}) {
  const qc = useQueryClient();

  const metrics = useQuery<EdgeMetricsResponse, Error>({
    queryKey: [...QUERY_KEY, query],
    queryFn: () => fetchEdgeMetrics(query),
    staleTime: 5_000,
    refetchInterval: 10_000,
  });

  const collect = useMutation({
    mutationFn: ({ agentId, sampleMs }: { agentId?: string; sampleMs?: number } = {}) =>
      requestSystemMetrics(agentId, sampleMs),
    onSuccess: () => {
      // Invalidate both metrics and edge-tasks lists
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      qc.invalidateQueries({ queryKey: ['system', 'edge-tasks'] });
    },
  });

  return { ...metrics, collect };
}
